export default __webpack_public_path__ + "static/icon-callout-ida-connect-36a41fa607c21be39b7bd680eb1dc967.png";